import { Button } from '@ui/components/Button';
import { SignInIcon } from '@ui/icons/SignInIcon/SignInIcon';

import styles from './AuthRequiredPage.module.css';

type Props = {
  onLogin?: () => void;
};

export function AuthRequiredPage({ onLogin }: Props) {
  return (
    <div className={styles.content}>
      <div className={styles.header}>Необходима авторизация</div>
      <div className={styles.subTitle}>
        Для доступа к этой странице необходимо войти в аккаунт проекта ChessOpen Турниры
      </div>
      <Button icon={<SignInIcon />} className={styles.button} onClick={onLogin}>
        Войти или зарегистрироваться
      </Button>
    </div>
  );
}
